import React from "react";
import ContentModerationList from "@/components/contentModeration/ContentModerationList";
import { breadcrumb_key } from "@/constants/translation/common.translation";
import { contentModeration } from "@/libs/routes";

/**
 * Content Moderation > Groups: list with search, status / date filters and View / Deactivate / Reactivate / Delete.
 */
const GroupsModerationList = () => (
  <ContentModerationList sectionKey="groups" />
);

GroupsModerationList.breadCrumbArray = [
  {
    name: breadcrumb_key.contentModeration.groups.list,
    pathname: contentModeration.groups.list,
    active: true,
  },
];

export default GroupsModerationList;
